
export const HIGH_LEVEL_CONFIG = {
    DEFAULT_LANGUAGE: "it",
    CHINESE_DOMAIN: "www.luiss.cn",
    // ENGLISH_DOMAIN: "localhost",
    ENGLISH_DOMAIN: process.env.REACT_APP_LUISS_ENGLISH_DOMAIN ? process.env.REACT_APP_LUISS_ENGLISH_DOMAIN : "www.luiss.edu",
    ITALIAN_DOMAIN: process.env.REACT_APP_LUISS_ITALIAN_DOMAIN ? process.env.REACT_APP_LUISS_ITALIAN_DOMAIN : "www.luiss.it",
    MAX_MAPPING_AGE_SECONDS: 600,
    GOOGLE_SEARCH_DELAY_SECONDS: 3,
    SCRIPTS_DELAY_SECONDS: 3,
    DEFAULT_IMAGE_URL: "https://www.luiss.it/icons/luiss144.png"
};

